module.exports = __webpack_public_path__ + "img/kintsugi.22e6aa42.png";